/* eslint-disable yola/react/require-default-props */
import React, { forwardRef } from 'react';
import classNames from 'classnames';
const Tab = forwardRef(
  ({ appearance, active = false, disabled = false, label, noBackground = false, onClick }, ref) => {
    const classes = classNames('ws-ui-tab', `ws-ui-tab--${appearance}`, {
      'ws-ui-tab--active': active,
      'ws-ui-tab--no-background': noBackground,
    });

    return (
      <button
        ref={ref}
        className={classes}
        role="tab"
        disabled={disabled}
        onClick={onClick}
        data-active={active}
      >
        <span className="ws-ui-tab__label-wrapper">{label}</span>
      </button>
    );
  }
);

Tab.displayName = 'Tab';

export default Tab;
